import React from 'react';
import { Badge } from '../../../../ForBrands/ui/BrandUI';
import { usePhoneTheme } from '../../../../ForBrands/useIsPhone';
import { NO_ADDITIONAL_TEAMS, formatDate, teamMetaLine } from '../coachProfileModel';
import { CopyButton, EmptyCard, KeyValueCard, SectionFooter, SectionHead, SupportLink } from '../coachProfilePieces';

const TeamRow = ({ name, meta, right, children }) => (
  <div className="flex flex-col gap-2 py-[14px]">
    <div className="flex items-start justify-between gap-4">
      <div className="flex min-w-0 flex-col gap-[2px]">
        <span className="bm-label-l text-bm-ink">{name}</span>
        {meta && <span className="bm-body-s text-bm-muted">{meta}</span>}
      </div>
      {right}
    </div>
    {children}
  </div>
);

// A team's own CACHE team code, so athletes can join that squad too. On a
// phone Copy drops under the code when the row runs out of room.
const TeamCode = ({ code, phone = false }) => (
  <div className={phone ? 'flex flex-wrap items-center gap-x-3 gap-y-2' : 'flex items-center gap-3'}>
    <span className="bm-overline !text-bm-tertiary">Team code</span>
    <span className="select-all bm-label-l tracking-[3px] text-bm-ink">{code}</span>
    <CopyButton text={code} size="sm" />
  </div>
);

// Figma 03 · Additional teams: program-director access an admin assigned,
// plus a league-admin grant when the coach holds one. Phones (2471:4084):
// the description, then the list in the mobile card or the empty block on
// its own; no Next.
const AdditionalTeamsSection = ({ teams = [], leagueAdmin, next, onNext }) => {
  const phone = usePhoneTheme();
  return (
    <>
      <SectionHead
        title="Additional teams"
        desc={
          <>
            Program-director access assigned by an admin. <SupportLink /> if you should be covering additional teams.
          </>
        }
      />
      {teams.length || leagueAdmin ? (
        <KeyValueCard>
          {leagueAdmin && <TeamRow name={leagueAdmin.label} meta="League admin" right={<Badge tone="passive">Every team</Badge>} />}
          {teams.map((team) => (
            <TeamRow
              key={`${team.teamId}:${team.league}`}
              name={team.name}
              meta={teamMetaLine(team)}
              right={team.addedAt ? <span className="shrink-0 bm-body-s text-bm-tertiary">Added {formatDate(team.addedAt)}</span> : null}
            >
              {team.teamCode && <TeamCode code={team.teamCode} phone={phone} />}
            </TeamRow>
          ))}
        </KeyValueCard>
      ) : (
        <EmptyCard>{NO_ADDITIONAL_TEAMS}</EmptyCard>
      )}
      {!phone && <SectionFooter next={next} onNext={onNext} />}
    </>
  );
};

export default AdditionalTeamsSection;
